import { render, staticRenderFns } from "./rList.vue?vue&type=template&id=3865281e&"
import script from "./rList.vue?vue&type=script&lang=js&"
export * from "./rList.vue?vue&type=script&lang=js&"
import style0 from "./rList.vue?vue&type=style&index=0&id=3865281e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports